import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton
} from 'framework7-react';
import * as axios from "axios/index";
import validator from 'validator';
import Loading from "../Loader/Loading";

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as vars from './Vars';

class MobileAuthentication extends Component{
    componentDidMount(){
        if (localStorage.getItem('logged') !== undefined && localStorage.getItem('logged') !== null )
        {
            this.$f7router.navigate('/')
            return false
        }
        else
            this.setState({
                requestLoading : false ,
            })



    }


    constructor(props){
        super(props)
        this.state = {
            fields : {
                verificationCode : ""
            } ,
            errors : {} ,
            modal : {
                modalMessageShow : false ,
                modalMessageBody : "" ,
                modalMessageTitle : "" ,
            } ,
            requestLoading : false ,

        }
    }


    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
                modalMessageBody : "" ,
                modalMessageTitle : "" ,
            }
        })
    }



    onPageBeforeIn(){
        this.props.toolbar(false)
    }



    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        if (target.value.length > 4 )
            return true;
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    handleSubmit(event){
        event.preventDefault()

        this.handleValidation( (valid) => {
            if (valid)
            {

                this.setState({
                    requestLoading : true
                })

                let data = new FormData()
                data.append('register_code' , this.state.fields.verificationCode )
                data.append('user_app_version' , '100' )
                data.append('a_token' , 'webapp' )
                data.append('mobile' , localStorage.getItem('mobile') )
                data.append('imei_code' , localStorage.getItem('imeiCode') )

                axios.post( vars.PreUrl + 'https://www.lavefood.com/v1/login' ,
                    data )
                    .then(response => {

                        let data = response.data.result[0]
                        if(data.error === 0)
                        {

                            localStorage.setItem('logged' , "logged")
                            localStorage.setItem('name' , data.name)
                            localStorage.setItem('users_ID' , data.users_ID)
                            localStorage.setItem('telephone' , data.firstTelephone)
                            this.setState({
                                requestLoading : false
                            })
                            this.$f7router.navigate('/')
                            return false
                        }
                        else
                        {
                            this.setState({
                                requestLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody : data.error_body ,
                                    modalMessageTitle : "خطا" ,
                                }
                            })
                        }
                        console.log(data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }

        })
    }


    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        if (validator.isEmpty(fields.verificationCode))
        {
            formIsValid = false;
            errors['verificationCode'] = 'کد را وارد کنید';
        }
        else if(! validator.isLength(fields.verificationCode , { min : 4 , max : 4}))
        {
            formIsValid = false;
            errors['verificationCode'] =  'کد را وارد کنید';
        }

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }

    render(){
        const {errors} = this.state;
        return(
            <Page name="Login" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>
                <Loading show={this.state.requestLoading} />
                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        اعتبار سنجی
                    </div>
                </div>


                <form onSubmit={this.handleSubmit.bind(this)} className="input-container">
                    <label htmlFor="phone" className="label">
                        <img src="https://www.lavefood.com/webappassets/images/smartphone-line.svg" className="img"/>
                        <div className="title">کد فعال سازی</div>
                        <h5 className="description">
                            کد 4 رقمی به شماره  {localStorage.getItem('mobile')} ارسال شد. آن را وارد کنید
                        </h5>
                    </label>
                    <div className="form-group">

                        <input
                            min={0}
                            max={9999}
                            type="number"
                            className={["form-control direction-ltr input-field font-en" , errors['verificationCode'] ? 'is-invalid' : ''].join(' ')}
                            name="verificationCode"
                            onChange={this.handleChange.bind(this)}
                            value={this.state.fields.verificationCode}  style={{zIndex : 50}} />
                        <span className={["invalid-feedback" ,  errors['verificationCode'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['verificationCode'] }</span>
                    </div>


                    <div className="input-group">
                        <button type="submit" className="btn btn-custom-4 ">
                            ورود
                        </button>
                    </div>

                </form>



                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow}  onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close">
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>

            </Page>

        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(MobileAuthentication);
